import { render, staticRenderFns } from "./IconHelpCenter.vue?vue&type=template&id=627f4b29&"
import script from "./IconHelpCenter.vue?vue&type=script&lang=js&"
export * from "./IconHelpCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports